import module from 'collapse-whitespace';
const collapseWhitespace = module;
export default collapseWhitespace;